import GeneralInfoPanel from "../components/panels/generalInfo/GeneralInfoPanel";
import OfferEditPanel from "../components/panels/offerEdit/OfferEditPanel";
import OfferExpansionSectionTitle from "../components/common/OfferExpansionSectionTitle";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import OfferEditSectionTitle from "../components/panels/offerEdit/components/OfferEditSectionTitle";
import OfferPlacedPanel from "../components/panels/offerPlaced/OfferPlacedPanel";
import OfferPlacedSectionTitle from "../components/panels/offerPlaced/components/OfferPlacedSectionTitle";
import AdditionalOfferEditPanel from "../components/panels/additionalOfferEdit/AdditionalOfferEditPanel";
import AdditionalOfferPlacedPanel from "../components/panels/additionalOfferPlaced/AdditionalOfferPlacedPanel";
import AuctionOfferEditPanel from "../components/panels/auctionOfferEdit/AuctionOfferEditPanel";
import AuctionOfferPlacedPanel from "../components/panels/auctionOfferPlaced/AuctionOfferPlacedPanel";
import AccessPanel from "../components/panels/access/AccessPanel";
import AdditionalOfferPlacedSectionTitle from "../components/panels/additionalOfferPlaced/components/AdditionalOfferPlacedSectionTitle";
import AdditionalOfferEditSectionTitle from "../components/panels/additionalOfferEdit/components/AdditionalOfferEditSectionTitle";
import AdditionalOfferEditAltPanel from "../components/panels/additionalOfferEditAlt/AdditionalOfferEditAltPanel";
import GeneralInfoSectionTitle from "../components/panels/generalInfo/components/GeneralInfoSectionTitle";
import AuctionOfferPlacedSectionTitle from "../components/panels/auctionOfferPlaced/components/AuctionOfferPlacedSectionTitle";
import AccessSectionTitle from "../components/panels/access/components/AccessSectionTitle";

export const StageSectionsOrder = ["GENERAL_INFO", "OFFER_EDIT", "OFFER_PLACED", "ADDITIONAL_OFFER_EDIT", "ADDITIONAL_OFFER_EDIT_ALT", "ADDITIONAL_OFFER_PLACED",
    "AUCTION_OFFER_EDIT", "AUCTION_OFFER_PLACED", "ACCESS"];

export const StageSections = {
    GENERAL_INFO: "GENERAL_INFO",
    OFFER_EDIT: "OFFER_EDIT",
    OFFER_PLACED: "OFFER_PLACED",
    ADDITIONAL_OFFER_EDIT: "ADDITIONAL_OFFER_EDIT",
    ADDITIONAL_OFFER_EDIT_ALT: "ADDITIONAL_OFFER_EDIT_ALT",
    ADDITIONAL_OFFER_PLACED: "ADDITIONAL_OFFER_PLACED",
    AUCTION_OFFER_EDIT: "AUCTION_OFFER_EDIT",
    AUCTION_OFFER_PLACED: "AUCTION_OFFER_PLACED",
    DASHBOARD: "DASHBOARD",
    ACCESS: "ACCESS"
}

export const StageSectionParamToSectionName = {
    "general-info": "GENERAL_INFO",
    "offer-edit": "OFFER_EDIT",
    "offer-placed": "OFFER_PLACED",
    "additional-offer-edit": "ADDITIONAL_OFFER_EDIT",
    "additional-offer-edit-alt": "ADDITIONAL_OFFER_EDIT_ALT",
    "additional-offer-placed": "ADDITIONAL_OFFER_PLACED",
    "auction-offer-edit": "AUCTION_OFFER_EDIT",
    "auction-offer-placed": "AUCTION_OFFER_PLACED",
    "access": "ACCESS"
}

export const StageSectionsUrlParams = {
    GENERAL_INFO: "general-info",
    OFFER_EDIT: "offer-edit",
    OFFER_PLACED: "offer-placed",
    ADDITIONAL_OFFER_EDIT: "additional-offer-edit",
    ADDITIONAL_OFFER_EDIT_ALT: "additional-offer-edit-alt",
    ADDITIONAL_OFFER_PLACED: "additional-offer-placed",
    AUCTION_OFFER_EDIT: "auction-offer-edit",
    AUCTION_OFFER_PLACED: "auction-offer-placed",
    ACCESS: "access"
}

export const StageSectionsComponents = {
    GENERAL_INFO: GeneralInfoPanel,
    OFFER_EDIT: OfferEditPanel,
    OFFER_PLACED: OfferPlacedPanel,
    ADDITIONAL_OFFER_EDIT: AdditionalOfferEditPanel,
    ADDITIONAL_OFFER_EDIT_ALT: AdditionalOfferEditAltPanel,
    ADDITIONAL_OFFER_PLACED: AdditionalOfferPlacedPanel,
    AUCTION_OFFER_EDIT: AuctionOfferEditPanel,
    AUCTION_OFFER_PLACED: AuctionOfferPlacedPanel,
    ACCESS: AccessPanel
}

export const StageSectionsTitles = {
    GENERAL_INFO: GeneralInfoSectionTitle,
    OFFER_EDIT: OfferEditSectionTitle,
    OFFER_PLACED: OfferPlacedSectionTitle,
    ADDITIONAL_OFFER_EDIT: AdditionalOfferEditSectionTitle,
    ADDITIONAL_OFFER_EDIT_ALT: AdditionalOfferEditSectionTitle,
    ADDITIONAL_OFFER_PLACED: AdditionalOfferPlacedSectionTitle,
    AUCTION_OFFER_EDIT: OfferExpansionSectionTitle,
    AUCTION_OFFER_PLACED: AuctionOfferPlacedSectionTitle,
    ACCESS: AccessSectionTitle
}

export const getSectionVariant = (section) => section ? (section.status === DemandValidationSectionStatus.OK ? 'Done' : (section.status === DemandValidationSectionStatus.DISABLED ? 'Wait' : (section.status === DemandValidationSectionStatus.ERROR ? 'Required' : (section.required ? 'Required' : 'Optional')))) : "Wait";